<template>
  <div class="page">
    <p class="p1">
      我的记录
      <span class="rt-pos" @click="goBack()"></span>
    </p>
    <div>
      <ul>
        <li class="li_class" v-for="(item,index) in packageList" :key="index">
          <div class="li-div">
            <span>发票状态：{{item.status}}</span>
            <span>开票金额：{{item.money}}</span>
          </div>
          <div class="li-div" v-if="item.type == 2">
            <span>快递公司：{{item.courierName}}</span>
            <span>单号：{{item.courierNum}}</span>
          </div>
          <div class="li-div">
            <span>申请时间：{{item.createTime}}</span>
            <!-- <span>开票时间：{{item.updateTime}}</span> -->
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { wx_userInvoiceList } from "@/api/api.js"; 
export default {
  data() {
    return {
      packageList:[]
    };
  },
  computed: {},
  methods: {
    transferCardStatus(status) {
      let obj = {
        0: "失败",
        1: "审核中",
        2: "已通过",
        3: "已开票",
        4: "已寄出",
        5: "其他",
        6: "已驳回",
        7: "已开票", // "不开票"对用户显示为“已开票”
      };
      return obj[status];
    },
    // 后退到上一页
    goBack(){
      this.$router.go(-1);
    },
    initData(){
      wx_userInvoiceList().then(res => {
        if(res.data.code == 200){
          this.packageList = res.data.data;
          this.packageList.map(item => {
            item.status = this.transferCardStatus(item.status)
          })
        }
      })
    }
  },
  created() {
    this.initData()
  },
  mounted() {
    window.document.title = "我的记录";
  },
};
</script>
<style scoped lang="less">
  .page{
    .p1{
      text-align: center;
      height: 40px;
      line-height: 40px;
      background: #F94040;
      color: #fff;
      font-size: 18px;
      position: relative;
      .rt-pos{
        position: absolute;
        left: 20px;
        top:14px;
        width: 12px;
        height: 12px;
        border-top: 2px solid gainsboro;
        border-left: 2px solid gainsboro;
        transform: rotate(-45deg);
      }
    }
    .li_class{
      padding: 5px 13px;
      width: 100%;
      // height: 80px;
      font-size: 13px;
      border-bottom: 2px solid #ededed;
      .li-div{
        display: flex;
        justify-content: space-between;
        margin-top: 5px;
      }
    }
  }
</style>

